import { useEffect } from "react";

const OG_IMAGE_URL = "https://premierelens.com/og-image.jpg";
const SITE_BASE_URL = "https://premierelens.com";

function upsertMetaByName(name, content) {
  if (!content) {
    return;
  }
  let element = document.head.querySelector(`meta[name="${name}"]`);
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute("name", name);
    document.head.appendChild(element);
  }
  element.setAttribute("content", content);
}

function upsertMetaByProperty(property, content) {
  if (!content) {
    return;
  }
  let element = document.head.querySelector(`meta[property="${property}"]`);
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute("property", property);
    document.head.appendChild(element);
  }
  element.setAttribute("content", content);
}

function upsertCanonical(href) {
  let link = document.head.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", href);
}

export default function usePageMeta({
  title,
  description,
  pathname,
  canonicalUrl,
  ogUrl,
  image = OG_IMAGE_URL,
  noindex = false,
  robots,
  ogType,
}) {
  useEffect(() => {
    const absoluteUrl = ogUrl || canonicalUrl || (pathname ? `${SITE_BASE_URL}${pathname}` : SITE_BASE_URL);
    const resolvedCanonicalUrl = canonicalUrl || (pathname ? `${SITE_BASE_URL}${pathname}` : null);
    const robotsContent = robots || (noindex ? "noindex" : "index,follow");

    if (title) {
      document.title = title;
      upsertMetaByName("title", title);
      upsertMetaByProperty("og:title", title);
      upsertMetaByName("twitter:title", title);
    }
    if (description) {
      upsertMetaByName("description", description);
      upsertMetaByProperty("og:description", description);
      upsertMetaByName("twitter:description", description);
    }
    if (ogType) {
      upsertMetaByProperty("og:type", ogType);
    }
    upsertMetaByProperty("og:url", absoluteUrl);
    upsertMetaByProperty("og:image", image);
    upsertMetaByName("twitter:card", "summary_large_image");
    upsertMetaByName("twitter:url", absoluteUrl);
    upsertMetaByName("twitter:image", image);
    upsertMetaByName("robots", robotsContent);
    if (resolvedCanonicalUrl) {
      upsertCanonical(resolvedCanonicalUrl);
    }
  }, [canonicalUrl, description, image, noindex, ogType, ogUrl, pathname, robots, title]);
}
